import { Injectable } from "@angular/core";
import {Subject} from "rxjs";
import {JsonApiService } from "@app/core/services/json-api.service";
import {Globals} from "@app/modulo-global/globals";
import {UsuarioService} from "@app/modulo-usuario/usuario/usuario.service";
import {NotificationService} from "@app/core/services/notification.service";
import {Router} from "@angular/router";
import {Usuario} from "../../../models/usuario";

@Injectable()
export class UserService {

  public user: Subject<any>;

  public userInfo = {
    username: 'Guest',
    rol: 'NONE',
  };

  constructor(
      private jsonApiService: JsonApiService,
      private global: Globals,
      private usuarioService: UsuarioService,
      public notificationService: NotificationService,
      private router: Router,
  ) {
    this.user = new Subject();
  }

  getLoginInfo(): Usuario {
    const userId = Number(localStorage.getItem('userId'));
    if (userId > 0) {
      if (!this.global.usuario) {
        this.usuarioService
            .getUserDataFromServer(userId, true)
            .then((res) => {
              this.global.usuario = res;
              this.userInfo.username = res.nombre;
              this.userInfo.rol = res.TipoUsuario.rol;
              localStorage.setItem('role', res.TipoUsuario.rol);
            }).catch((err) => {
          this.handleSessionError(err);
        });
      } else {
        this.usuarioService
            .getUserSessionFromServer(true)
            .then((res) => {
            }).catch((err) => {
          this.handleSessionError(err);
        });
      }
    }
    return this.global.usuario;
  }

  /**
   * Un fallo al traer los datos del usuario (header/rol) en la carga casi
   * siempre es una SESIÓN INVÁLIDA, no una cuenta bloqueada: el token es
   * estático y embebe el hash de la contraseña (ver TokenAuthenticator del
   * backend), así que un cambio/reset/rehash de contraseña lo invalida y el
   * backend responde 401/403. Antes esto caía en /auth/locked ("su cuenta ha
   * sido bloqueada"), confundiendo una sesión vencida con una cuenta baneada.
   *
   * Ahora: 401/403 → limpiar la sesión y mandar a login (con returnUrl para
   * volver al deep link tras reloguearse). Otros errores (red/5xx) NO tiran la
   * sesión: solo avisan. La pantalla /auth/locked queda reservada para cuentas
   * realmente inactivas (activo=false), que detecta el login en dirigirUsuario().
   */
  handleSessionError(err) {
    const status = err ? err.status : null;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('role');
      this.global.setUsuario(null);
      const currentUrl = this.router.url || '';
      const returnUrl = currentUrl && currentUrl.indexOf('/auth') !== 0 ? currentUrl : null;
      this.notificationService.smallBox({
        title: 'Sesión expirada',
        content: 'Tu sesión venció. Iniciá sesión nuevamente.',
        color: '#ffae43',
        timeout: 5000,
        icon: 'fa fa-sign-in'
      });
      this.router.navigate(['/auth/login'], returnUrl ? { queryParams: { returnUrl } } : {});
    } else {
      this.notificationService.smallBox({
        title: 'Error de conexión',
        content: (err && err.message) || 'No pudimos cargar tus datos. Reintentá en unos segundos.',
        color: '#a90329',
        timeout: 5000,
        icon: 'fa fa-exclamation-triangle'
      });
    }
  }

  public getRole(): Promise<any> {
    return Promise.all([
      this.usuarioService
          .getUserDataFromServer(Number(localStorage.getItem('userId')), true)
          .then((res) => {
            this.global.usuario = res;
            this.userInfo.username = res.nombre;
            this.userInfo.rol = res.TipoUsuario.rol;
          }).catch((err) => {
        this.handleSessionError(err);
      })
    ]).then(() => {return this.userInfo.rol})
  }

  public getUserInfo(): Promise<Usuario> {
    return Promise.all([
      this.usuarioService
          .getUserDataFromServer(Number(localStorage.getItem('userId')), true)
          .then((res) => {
            this.global.usuario = res;
            this.userInfo.username = res.nombre;
            this.userInfo.rol = res.TipoUsuario.rol;
          }).catch((err) => {
        this.handleSessionError(err);
      })
    ]).then(() => {return this.global.usuario})
  }


}
